import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'dot']

  connect() {
    this.currentIndex = 0
    this.totalSlides = this.slideTargets.length
    // this.startAutoPlay()
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  startAutoPlay() {
    this.interval = setInterval(() => {
      this.next()
    }, 5000) // Change slide every 5 seconds
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.totalSlides
    this.goToSlide(nextIndex)
  }

  goToSlide(index) {
    if (typeof index !== 'number') {
      index = parseInt(event.currentTarget.dataset.index)
    }

    // Hide all slides
    this.slideTargets.forEach((slide) => slide.classList.add('hidden'))

    // Show current slide
    this.slideTargets[index].classList.remove('hidden')

    // Update dots and their alt text
    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle('bg-tiger', i === index)
      dot.classList.toggle('bg-night-20', i !== index)
      // Update alt text based on whether this dot represents current slide
      dot.setAttribute(
        'alt',
        i === index
          ? this.element.dataset.currentText
          : this.element.dataset.nextText
      )
    })

    this.currentIndex = index

    // Reset interval
    clearInterval(this.interval)
    // this.startAutoPlay()
  }
}
